import { stringSearch } from '@luminovo/design-system';
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { ProjectPcbLayout } from '@/areas/pcb/Pcb/PcbLayout/ProjectPcbLayout';
import { assembliesModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// The shell of the PCB tabs, so switching tabs keeps the selected document and the PCB websocket updater.
export const Route = createFileRoute('/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb')({
    // The same access as its tabs; the navbar reads the tab's chrome.
    staticData: {
        access: { permissions: ['view:assembly'], modulePermissions: assembliesModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    // A layout's `Route.useSearch` is typed from its own `validateSearch` and its parents', not its tabs'.
    validateSearch: stringSearch({ currentParentAssemblyId: 'optional' }),
    component: RouteComponent,
    // The shell's state belongs to one assembly's PCB; the router would keep it across a param change.
    remountDeps: ({ params }) => params.assemblyId,
});

function RouteComponent(): JSX.Element {
    const { projectId, assemblyId } = Route.useParams();
    const currentParentAssemblyId = Route.useSearch({ select: (search) => search.currentParentAssemblyId });
    return (
        <ProjectPcbLayout
            projectId={projectId}
            assemblyId={assemblyId}
            currentParentAssemblyId={currentParentAssemblyId}
        >
            <Outlet />
        </ProjectPcbLayout>
    );
}
